<!--here breadcrump class has been used to display the exact location of the page
commented by Prerna Singh on 13 february 2024-->

<div style="background-color: #dedede;line-height: 0px;">
    <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
                    font-size: 12px;margin-bottom: 0 !important;">
        <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
            <a (click)="goToPageLink(item.page_ref)">
                {{ item.page_title }}
            </a>
        </li>
    </ol>
</div>
<!--here class is used to add title and save the components in it
commented by prerna singh on 14 feb 2024-->
<mat-toolbar>
    <h6 class="show-title">{{showEditUsertxt}}</h6>
    <button *ngIf="savebtn" class="more-btn-custom" mat-raised-button (click)="addDevice()">
        <i class="material-icons icon-layout-custom">add_circle</i>
        &nbsp;
        Add New
    </button>
</mat-toolbar>
<!--fxLayoutAlign is an API used to change the alignment of children elements in flex box container 
commented by Prerna Singh on 16 feb 2024 -->
<div fxLayoutAlign="center center" fxLayout="column" style="padding: 16px; margin-bottom: 100px;"
    class="add_group_form">
    <form [formGroup]="uForm" (ngSubmit)="saveSiteGroup()">
        <div class="form_field_outer">
            <mat-form-field class="example-full-width" floatLabel="always">
                <input placeholder="Site name &nbsp;*" matInput type="text" formControlName="site_name" id="site_name">
                <!-- <mat-placeholder class="placeholder">Site name &nbsp;*</mat-placeholder> -->
            </mat-form-field>
            <!-- <control-messages class="error_msg" [control]="uForm.controls.site_name"></control-messages> -->
        </div>
<!--form_field_outer is used to structuring the code in a proper index commented by Prerna Singh on 16 feb 2024-->
        <div class="form_field_outer">
            <mat-form-field class="example-full-width" floatLabel="always">
                <input matInput placeholder="Application name &nbsp;*" disabled type="text" formControlName="group_name" id="group_name">
                <!-- <mat-placeholder class="placeholder">Application name &nbsp;*</mat-placeholder> -->
            </mat-form-field>
        </div>
<!--form_field_outer is used to structuring the code in a proper index commented by Prerna Singh on 16 feb 2024-->
        <div class="form_field_outer">
            <mat-form-field class="example-full-width" floatLabel="always">
                <input matInput disabled type="text" placeholder="Application description" formControlName="group_description" id="group_description">
                <!-- <mat-placeholder class="placeholder">Application description</mat-placeholder> -->
            </mat-form-field>
        </div>

        <div class="btn-box text-center" *ngIf="savebtn">
            <button mat-raised-button style="border-radius: 50px;" type="submit" [disabled]="!uForm.valid">Save</button>
        </div>

        <div class="btn-box text-center" *ngIf="showUpdateBtn">
            <button  mat-raised-button style="border-radius: 50px;" type="button"
                (click)="saveDevice()" [disabled]="!uForm.valid">Update</button>
        </div>
    </form>

</div>
